/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import { ColDef, TableSetting, TableStd, ToolbarSetting } from 'app/components'
import React from 'react'
import { SeasonDto, SeasonService, SeasonStatusEnum, SystemDateDisplayFormat } from 'app/modules/core'
import { useNavigate } from 'react-router-dom'
import { KTSVG } from '_metronic/helpers'

import moment from 'moment'
import clsx from 'clsx'
import { toast } from 'react-toastify'
import { catchErrorMsg } from 'app/modules/core/helpers/Helper'
import { useGlobalModalContext } from 'setup/context/GlobalModal'



const SeasonSettingPage: FC = () => {
    const navigate = useNavigate()
    const [reload, setReload] = React.useState<{}>()
    const [data, setData] = useState<SeasonDto[]>([])
    const msgBox = useGlobalModalContext()
    // const initParam: AnnouncementFilterDto = {
    //     page: 0,
    //     length: 10
    // }
    // const [searchParam, setSearchParam] = useState<AnnouncementFilterDto>(initParam)

    const columnDef: ColDef<SeasonDto>[] = [
        {
            label: 'Id',
            renderItem: ({item, index}) => item.id,
            hidden: true
        },
        {
            label: 'ชื่อ',
            renderItem: ({item, index}) => item.title,
        },
        {
            label: 'สถานะ',
            renderItem: ({item, index}) => <div className={clsx(
                'badge',
                { 'bg-primary': item.status === SeasonStatusEnum[SeasonStatusEnum.New] },
                { 'bg-success': item.status === SeasonStatusEnum[SeasonStatusEnum.Started] },
                { 'bg-info': item.status === SeasonStatusEnum[SeasonStatusEnum.Ended] },
                { 'bg-secondary': item.status === SeasonStatusEnum[SeasonStatusEnum.InActive] },
            )}>{item.status}</div>
        },
        {
            label: 'วันที่เริ่ม',
            renderItem: ({item, index}) => moment(item.periodStart).format(SystemDateDisplayFormat)
        },

        {
            label: 'วันที่สิ้นสุด',
            renderItem: ({item, index}) => moment(item.periodEnd).format(SystemDateDisplayFormat)
        },
        {
            label: 'วันหมดเขต',
            renderItem: ({item, index}) => moment(item.expiredDate).format(SystemDateDisplayFormat)
        },

    ]

    const tableSetting: TableSetting<SeasonDto> = {
        showColAction: true,
        onBtnEditClick: (e: any, id: any) => navigate('/setting/seasons/' + id),
        onBtnDeleteClick: (e:any, id) => {
            msgBox.showModal({ title: 'Warning', message: 'Are you sure you want to delete.' }, (type) => {
                if (type === 'ok') {              
                    SeasonService.Delete(id).then((res) => {
                        toast.success('Delete Success.')
                        setReload({})
                    })
                    .catch((res) => {
                        toast.error(catchErrorMsg(res))
                    })
                }
            })
        },
        primaryKey: (item: SeasonDto) => item.id,
    }
    const toolbarSetting: ToolbarSetting = {
        showBtnAdd: true,
        showFilter: false,
        showSearch: false,
        btnAddText: 'เพิ่ม Season',
        searchTextValue: '',
        onBtnAddClick: () => navigate('/setting/seasons/new')
    }

    useEffect(() => {
        const load = () => {
            SeasonService.GetSeasons().then((result) => {
                const row = result.data.result
                setData(row)
            })
        }
        load()
    }, [reload])

    return (
        <>
            <PageTitle breadcrumbs={[]}></PageTitle>
            <div className={`card mb-5 mb-xl-8`}>

                {/* begin::Body */}
                <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div >
                        {/* begin::Table */}
                        <TableStd
                            tableSetting={tableSetting}
                            toolbarSetting={toolbarSetting}
                            columns={columnDef}
                            data={data}
                        />
                        {/* end::Table */}
                    </div>

                    {/* end::Table container */}
                </div>
                {/* begin::Body */}
            </div>
        </>
    )
}
export { SeasonSettingPage }
